import { render, staticRenderFns } from "./NewAddressInput.vue?vue&type=template&id=853e082e"
import script from "./NewAddressInput.vue?vue&type=script&lang=js"
export * from "./NewAddressInput.vue?vue&type=script&lang=js"
import style0 from "./NewAddressInput.vue?vue&type=style&index=0&id=853e082e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports